// import mpro from './index';

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(($) => {

	// For non-delegates
	mpro.initStatics(mpro.get$B());

	// Time to execute all pending js functions
	mpro.loadPendingCallbacks();

	// Emit the init event
	mpro.emit('ready', $);
});

export default mpro;
